import { render, staticRenderFns } from "./EmployerContributionOther.vue?vue&type=template&id=3a5140a7&"
import script from "./EmployerContributionOther.vue?vue&type=script&lang=js&"
export * from "./EmployerContributionOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports